// Recipe gallery: a swipeable row of photos and videos with arrows and dots. The visible video
// plays (muted, looping) and every other video pauses, so Reels/TikToks feel alive without
// several videos playing at once.

document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeSection_RecipeGallery', () => ({
    index: 0,
    count: 0,

    init() {
      this.count = this.slides().length;
      this.$nextTick(() => this.syncVideos());
    },

    slides() {
      return [...this.$refs.track.children];
    },

    go(i) {
      const target = Math.max(0, Math.min(this.count - 1, i));
      this.$refs.track.scrollTo({ left: target * this.$refs.track.clientWidth });
    },

    onScroll() {
      const track = this.$refs.track;
      this.index = Math.round(track.scrollLeft / track.clientWidth);
      this.syncVideos();
    },

    syncVideos() {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.slides().forEach((slide, i) => {
        const video = slide.querySelector('video');
        if (!video) return;
        if (i === this.index && !reduceMotion) {
          video.muted = true;
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    },
  }));

  // "Shop the recipe" cards: add the product to the cart and open the cart drawer,
  // the same way the theme's own add-to-cart buttons do
  Alpine.data('ThemeSection_RecipeProduct', () => ({
    adding: false,
    added: false,
    error: '',

    add(form) {
      if (this.adding) return;
      this.adding = true;
      this.error = '';

      const id = Number(new FormData(form).get('id'));
      fetch(window.Shopify.routes.root + 'cart/add.js?sections=cart-items,cart-footer,cart-item-count', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
      })
        .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
        .then(({ ok, data }) => {
          if (!ok) {
            this.error = data.description || data.message || 'Something went wrong. Please try again.';
            return;
          }
          this.added = true;
          setTimeout(() => (this.added = false), 2500);
          document.body.dispatchEvent(
            new CustomEvent('shapes:modalcart:afteradditem', { bubbles: true, detail: { response: data } })
          );
        })
        .catch(() => {
          this.error = 'Something went wrong. Please try again.';
        })
        .finally(() => {
          this.adding = false;
        });
    },
  }));
});
